import "./App.css";
import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Header from "./components/header";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Home from "./pages/home";
import About from "./pages/about";
import Job from "./pages/job";
import Contact from "./pages/contact";
import Services from "./pages/services";
import Blog from "./pages/blog/blog";
import BlogPost from "./pages/blog/blogpost";

import Jobdesc from "./pages/jobdesc";
import NotFound from "./pages/notfound";
import { HelmetProvider } from "react-helmet-async";
import { SectionsProvider } from "./store/section-context";
import BlogParent from "./pages/blog/blogparent";
import ScrollToTop from "./components/scrolltop";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
          <div className="app">
            <Header />
            <Navbar />
            <SectionsProvider>
              <Routes>
                {/* <Route element={<SectionsWrapper />}> */}
                <Route path="/" exact element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/job" element={<Job />} />
                <Route path="/services" element={<Services />} />
                <Route path="/blog" element={<BlogParent />}>
                  <Route index element={<Blog />} />
                  <Route
                    path=":postId/post/:slug"
                    element={<BlogPost />}
                  />{" "}
                  {/* Renders BlogPost on /blog/:id/post/:slug */}
                </Route>

                <Route path="/jobdesc/:jobId" element={<Jobdesc />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />

                {/* </Route> */}

                {/* <Route path="/notfound" element={<NotFound />} /> */}
              </Routes>
            </SectionsProvider>
            <Routes>
              <Route path="/notfound" element={<NotFound />} />
            </Routes>
            <Footer />
          </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
